import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Your account is ready. Welcome!");
      navigate("/hub");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="w-full max-w-md animate-fade-up">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 rounded-2xl bg-[#E8A87C] flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="font-head font-extrabold text-xl">WAIT <span className="text-[#E8A87C]">Mental Health</span></span>
        </Link>
        <div className="bg-white rounded-3xl p-8 shadow-sm border border-black/5">
          <h1 className="font-head font-extrabold text-2xl mb-1">Create your account</h1>
          <p className="text-muted-foreground text-sm mb-6">Start building healthier habits today.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-semibold">Name</label>
              <input
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-1 w-full rounded-2xl border border-black/10 px-4 py-3 outline-none focus:border-[#E8A87C] transition-colors"
                data-testid="register-name"
              />
            </div>
            <div>
              <label className="text-sm font-semibold">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full rounded-2xl border border-black/10 px-4 py-3 outline-none focus:border-[#E8A87C] transition-colors"
                data-testid="register-email"
              />
            </div>
            <div>
              <label className="text-sm font-semibold">Password</label>
              <input
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full rounded-2xl border border-black/10 px-4 py-3 outline-none focus:border-[#E8A87C] transition-colors"
                data-testid="register-password"
              />
            </div>
            {error && (
              <p className="text-sm text-red-600" data-testid="register-error">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#E8A87C] text-white font-semibold py-3.5 rounded-full hover:-translate-y-0.5 transition-transform disabled:opacity-60"
              data-testid="register-submit"
            >
              {loading ? "Creating…" : "Create account"}
            </button>
          </form>
          <p className="text-sm text-center mt-6 text-muted-foreground">
            Already have an account?{" "}
            <Link to="/login" className="font-semibold text-[#E8A87C]" data-testid="register-to-login">
              Log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
